import { connect } from 'react-redux';
import { moveNext, movePrev } from '../redux/actionCreators';
import { getDuperbrowseNavigation, getIsDuperbrowseActive, getIsKeyboardDuperbrowseAllowed, getPreloadingEnabled } from '../redux/selectors';
const mapStateToProps = (state)=>({
        navigation: getDuperbrowseNavigation(state),
        isDuperbrowseActive: getIsDuperbrowseActive(state),
        enableKeyboardNavigation: getIsKeyboardDuperbrowseAllowed(state),
        preloadEnabled: getPreloadingEnabled(state)
    });
const mapDispatchToProps = {
    moveNext,
    movePrev
};
export default connect(mapStateToProps, mapDispatchToProps);
